import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";
import axios from "axios";
import { API_MAI_FALI } from "../utils";
import { logoutUser } from "../actions/AuthAction";

const PelaporanKeberadaan = (props) => {
  const [formData, setFormData] = useState({
    nama_organisasi: "",
    email_organisasi: "",
    alamat_sekretariat: "",
    bentuk_organisasi: "",
    jenis_organisasi: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      logoutUser(props.history);
    }
  }, [props.history]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Validate required fields
    const requiredFields = [
      "nama_organisasi",
      "email_organisasi",
      "alamat_sekretariat",
      "bentuk_organisasi",
      "jenis_organisasi",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      setError(
        `Mohon lengkapi field yang wajib diisi: ${missingFields.join(", ")}`
      );
      setLoading(false);
      return;
    }

    try {
      console.log("Submitting data:", formData);

      const response = await axios.post(`${API_MAI_FALI}ormas`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000, // 10 second timeout
      });

      console.log("Response:", response.data);

      if (response.data.success) {
        setSuccess(true);
        setFormData({
          nama_organisasi: "",
          email_organisasi: "",
          alamat_sekretariat: "",
          bentuk_organisasi: "",
          jenis_organisasi: "",
        });
      }
    } catch (error) {
      console.error("Error details:", error);

      if (error.response) {
        // Server responded with error status
        setError(
          `Error ${error.response.status}: ${
            error.response.data?.message || error.response.statusText
          }`
        );
      } else if (error.request) {
        // Request was made but no response received
        setError(
          "Tidak dapat terhubung ke server. Pastikan backend berjalan di port 5000."
        );
      } else {
        // Something else happened
        setError("Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
      }
    } finally {
      setLoading(false);
    }
  };

  const bentukOrganisasiOptions = [
    { value: "Berbadan Hukum", label: "Berbadan Hukum" },
    { value: "Tidak Berbadan Hukum", label: "Tidak Berbadan Hukum" },
  ];

  const jenisOrganisasiOptions = [
    { value: "Yayasan", label: "Yayasan" },
    { value: "Perkumpulan", label: "Perkumpulan" },
    { value: "Forum", label: "Forum" },
    { value: "Lembaga", label: "Lembaga" },
    { value: "Lainnya", label: "Lainnya" },
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <i className="tim-icons icon-bullet-list-67 text-primary" />
                  Pelaporan Keberadaan ORMAS
                </CardTitle>
                <p className="text-muted">
                  Berdasarkan ketentuan dalam Pasal 9 Peraturan Pemerintah
                  Republik Indonesia Nomor 58 Tahun 2016 tentang Pelaksanaan
                  Undang-Undang Nomor 17 Tahun 2013 tentang Organisasi
                  Kemasyarakatan, bahwa semua Ormas diwajibkan untuk melaporkan
                  keberadaan kepengurusannya di daerah kepada Badan Kesbangpol.
                </p>
              </CardHeader>
              <CardBody>
                {success && (
                  <Alert color="success">
                    Data pelaporan keberadaan ORMAS berhasil disimpan!
                  </Alert>
                )}

                {error && <Alert color="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Nama Organisasi *</Label>
                        <Input
                          type="text"
                          name="nama_organisasi"
                          value={formData.nama_organisasi}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Email Organisasi *</Label>
                        <Input
                          type="email"
                          name="email_organisasi"
                          value={formData.email_organisasi}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label>Alamat Sekretariat *</Label>
                    <Input
                      type="textarea"
                      name="alamat_sekretariat"
                      value={formData.alamat_sekretariat}
                      onChange={handleInputChange}
                      rows="3"
                      required
                    />
                  </FormGroup>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Bentuk Organisasi *</Label>
                        <Input
                          type="select"
                          name="bentuk_organisasi"
                          value={formData.bentuk_organisasi}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Pilih Bentuk Organisasi</option>
                          {bentukOrganisasiOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Jenis Organisasi *</Label>
                        <Input
                          type="select"
                          name="jenis_organisasi"
                          value={formData.jenis_organisasi}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Pilih Jenis Organisasi</option>
                          {jenisOrganisasiOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12" className="text-right">
                      <Button
                        type="button"
                        color="secondary"
                        className="mr-2"
                        onClick={() => props.history.push("/data-ormas")}
                      >
                        Batal
                      </Button>
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? "Menyimpan..." : "Simpan Data ORMAS"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PelaporanKeberadaan;
